export default {
  title: "Bedrijven"
}
